import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Pagination from './../../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import BookingService from '../../../../services/cargobooking.service';
import Util from '../../../../../shared/util/util';
import CONSTANT from '../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import apiUrl from '../../../../../../constants'
import createWarehouse from './abfrlcreatewarehouse/index.vue'

export default {
  name: 'abfrlwarehouse',
  components: {
    VueElementLoading,
    Pagination,
    DatePicker,
    CustomExpandableTable,
    Treeselect,
    createWarehouse
  },
  data: function() {
    return {
      tableColumn:['Plant','Row Type','Business Type','Brand','Postal Code','City','Name','Status ABFRL','Created Date'],
      tableItems:[],
      isLoading:false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      showCreateWarehouse:false,
      PLNT:'',
      RowType:'',
      BusinessType:'',
      Brand:'',
      PostalCode:'',
      City:'',
      Name:''
    }
  },
  async mounted() {
    this.isLoading = true;
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    await this.getabfrlwarehousedata();
    this.isLoading = false;
 },
  methods:{
  onPageChange(page) {
    this.currentPage = page;
    this.offset = (page - 1) * this.pageLimit
    this.getabfrlwarehousedata();
  },
  searchFilter(){
    this.currentPage = 1;
    this.offset = 0;
    this.getabfrlwarehousedata();
  },
  resetSearch(){
    this.PLNT = '',
    this.RowType = '',
    this.BusinessType = '',
    this.Brand = '',
    this.PostalCode = '',
    this.City = '',
    this.Name = ''
    this.getabfrlwarehousedata();
  },
  createWarehouse(){
    this.showCreateWarehouse = true;
  },
  callParent(){
    this.showCreateWarehouse = false;
    this.resetSearch();
  },
  async getabfrlwarehousedata(){
    try {
      this.isLoading = true;
      let inputPayload = {
        "offset": this.offset,
        "limit": this.pageLimit,
      }
      this.PLNT && (inputPayload.plnt = this.PLNT);
      this.RowType && (inputPayload.rowType = this.RowType);
      this.BusinessType && (inputPayload.businessType = this.BusinessType);
      this.Brand && (inputPayload.brand = this.Brand);
      this.PostalCode && (inputPayload.postalCode = this.PostalCode);
      this.City && (inputPayload.city = this.City);
      this.Name && (inputPayload.name = this.Name);

      let result = await BookingService.GetAbfrlWarehouseData(inputPayload)
      this.totalCount = result.data.data.count;
      if(this.totalCount>0){
        this.tableItems = result.data.data.rows.map((el)=>{
          return {
            'id':el.id,
            'Plant': el.plnt,
            'Row Type': el.rowtype,
            'Business Type': el.businesstype,
            'Brand':el.brand,
            'Postal Code':el.postalcode,
            'City':el.city2,
            'Name':el.name,
            'Status ABFRL':el.statusafbrl,
            'Created Date': Util.displayDateTimeFormat(el.createddate)
          }
        })
      }else{
        this.tableItems = [];
      }
      if (this.totalCount < this.pageLimit) {
        this.totalPage = 1
      } else {
        this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
      }
      this.isLoading = false;
      }
      catch(err){
      console.log(err);
      this.isLoading = false;
    }
  },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/abfrlLogs/abfrlwarehouse/abfrlwarehouse.component.js